import { useAuthenticatedApiClient } from '@guiker/react-framework'
import { AuthenticatedApiClient } from '@guiker/rental-listing-shared'

export const useAuthenticatedListingApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
